import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h2>RnR - Roots & Routes</h2>
      <p>Explore Jharkhand's hidden gems with ease!</p>
    </footer>
  );
};

export default Footer;
